import { trigger, style, state, transition, animate } from '@angular/animations';

const showHidden = trigger('showHidden', [
  state('hidden', style({
    zIndex: -10,
    opacity: 0
  })),
  state('show', style({
    zIndex: 12,
    opacity: 1
  })),
  transition('show => hidden', [
    animate('0.3s')
  ]),
  transition('hidden => show', [
    animate('0.2s')
  ]),
]);

export { showHidden }